import { AppModules } from 'appContainer/types';
import {
  DynamicRouteTitle,
  IndexRouteContent,
  LayoutRouteContent,
  PathRouteContent,
  RouteNode,
} from 'router/declarative/routeNode';

export const routes = {
  path: '/search',
  appModule: AppModules.SEARCH,
  content: async (): PathRouteContent =>
    (await import('./SearchLayout')).SearchLayout,
  children: [
    {
      path: { index: true },
      title: async (): DynamicRouteTitle =>
        (await import('./searchTitles')).advancedSearchTitle$,
      content: async (): IndexRouteContent =>
        (await import('./AdvancedSearch/AdvancedSearch')).AdvancedSearch,
    },
    {
      path: '/advanced-search',
      title: async (): DynamicRouteTitle =>
        (await import('./searchTitles')).advancedSearchTitle$,
      content: async (): PathRouteContent =>
        (await import('./AdvancedSearch/AdvancedSearch')).AdvancedSearch,
    },
    {
      path: { layout: true },
      content: async (): LayoutRouteContent =>
        (await import('./GraphSearchBoundary')).GraphSearchBoundary,
      children: [
        {
          path: '/gremlin',
          title: async (): DynamicRouteTitle =>
            (await import('./searchTitles')).gremlinSearchTitle$,
          content: async (): PathRouteContent =>
            (await import('./GremlinSearch/GremlinSearch')).GremlinSearch,
        },
      ],
    },
    {
      path: '/graphlake',
      title: async (): DynamicRouteTitle =>
        (await import('./searchTitles')).graphlakeSearchTitle$,
      content: async (): PathRouteContent =>
        (await import('./GraphlakeSearch/GraphlakeSearch')).GraphlakeSearch,
    },
  ],
} as const satisfies RouteNode;
